import { FeatureFlag } from 'types/domainModels';
import { Environment } from 'util/environment';
import { create } from 'zustand';

interface GlobalState {
  flags: FeatureFlag[];
  envs: {
    frontendEnv: Environment;
    backendEnv: Environment;
    databaseEnv: Environment;
  };
}

export const useGlobalStore = create<GlobalState>()(() => ({
  flags: [],
  envs: {
    frontendEnv: 'unknown',
    backendEnv: 'unknown',
    databaseEnv: 'unknown',
  },
}));
